import { money, longDate } from "./format";

// Estimated-value time series (date · estimate · range), mirroring the valuation
// history table on the ez Home Search user-home page. Renders nothing for a
// single-point (or empty) history — there's nothing to compare yet.
export default function ValuationHistory({ history, heading = "Estimated value history" }) {
  if (!history || history.length < 2) return null;

  return (
    <section className="ssc-report-section">
      <h3>{heading}</h3>
      <div className="ssc-report-table-wrap">
        <table className="ssc-report-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Estimate</th>
              <th>Low</th>
              <th>High</th>
            </tr>
          </thead>
          <tbody>
            {history.map((h, i) => (
              <tr key={`${h.date}-${i}`}>
                <td>{longDate(h.date)}</td>
                <td className="is-strong">{money(h.value)}</td>
                <td>{h.low ? money(h.low) : "—"}</td>
                <td>{h.high ? money(h.high) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
